import { EntityLevel } from '@suntex.fim/enums';

import {
  type EntityLayoutProps,
  createEntityLayout,
} from './createEntityLayout';

export type RegionLayoutProps = EntityLayoutProps;

/** Layout wrapper for region-scoped routes (`/region/:regionId/...`). */
export const RegionLayout = createEntityLayout({
  entityLevel: EntityLevel.Region,
  paramName: 'regionId',
});
